import { IconHeartOff24, IconHeartOn24 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './FavoriteButtonMobile.css';

export interface IFavoriteButtonMobileProps {
  isFavorite: boolean;
  onClick?(): void;
}

export const FavoriteButtonMobile: React.VFC<IFavoriteButtonMobileProps> = ({ isFavorite, onClick }) => {
  const HeartIcon = isFavorite ? IconHeartOn24 : IconHeartOff24;

  return (
    <button
      className={styles['button']}
      onClick={onClick}
      aria-label={isFavorite ? 'В избранном' : 'В избранное'}
      data-testid="FavoriteButtonMobile"
      type="button"
    >
      <HeartIcon color="warning_100" />
    </button>
  );
};
